module.exports = __webpack_public_path__ + "static/media/external-link-alt.9fe765b9.svg";